<template>
  <require from="controls/as-widget-list"></require>
  <require from="controls/as-form-section.html"></require>

  <div class="trip-details-section">
    <as-form-section heading.bind="heading" intro.bind="intro">
      <div slot="body">
        <as-widget-list items.bind="segments" reorderable="true" disabled.bind="disabled"></as-widget-list>
      </div>
      <div slot="footer" class="sc-buttons-container" show.bind="!disabled">
        <button type="button" class="btn btn-light" click.delegate="addCity()" disabled.bind="disabled">
          <i class="fas fa-map-marker-alt"></i> Add City
        </button>
        <button type="button" class="btn btn-light" click.delegate="addTransport()" disabled.bind="disabled">
          <i class="fas fa-plane"></i> Add Transport
        </button>
        <button type="button" class="btn btn-light" click.delegate="addAccommodation()" disabled.bind="disabled">
          <i class="fas fa-bed"></i> Add Accommodation
        </button>
        <button type="button" class="btn btn-light" click.delegate="addNote()" disabled.bind="disabled">
          <i class="fas fa-map"></i> Add Note
        </button>
      </div>
    </as-form-section>
  </div>
</template>
